import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';
import { getSettings } from '../services/api';

const LanguageContext = createContext();

export const FONTS = [
  { value: 'IBM Plex Sans Arabic', label: 'IBM Plex Sans Arabic', weight: 300, lang: 'ar' },
  { value: 'Noto Sans', label: 'Noto Sans', weight: 300, lang: 'en' },
];

const getFontForLang = (language) => language === 'ar' ? FONTS[0] : FONTS[1];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('app_lang') || 'en');
  const [font, setFont] = useState('Noto Sans');
  const [fontSize, setFontSize] = useState(14);
  const t = translations[lang];

  const toggleLang = () => setLang(prev => {
    const next = prev === 'en' ? 'ar' : 'en';
    localStorage.setItem('app_lang', next);
    return next;
  });

  // Auto-switch font when language changes
  useEffect(() => {
    setFont(getFontForLang(lang).value);
  }, [lang]);

  const currentFont = FONTS.find(f => f.value === font) || getFontForLang(lang);
  const fontFamily = `'${currentFont.value}', sans-serif`;
  const fontWeight = currentFont.weight;

  // Load font size from API on mount
  useEffect(() => {
    const loadFontSettings = async () => {
      try {
        const { data } = await getSettings();
        if (data.fontSize) setFontSize(data.fontSize);
      } catch (err) {
        // Keep defaults if API fails
      }
    };
    loadFontSettings();
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang, font, setFont, fontFamily, fontWeight, fontSize, setFontSize }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
